export const ClearTaxMapper = (clearTax) => {
    var _a;
    if (clearTax)
        return {
            authCode: ((_a = clearTax.data) === null || _a === void 0 ? void 0 : _a.authCode) || "",
            redirectionURL: clearTax.data.redirectionURL,
        };
    return {};
};
